<script>
import Swal from 'sweetalert2'
import moment from 'moment-timezone'

export default {
  name: 'SelectMonthModal',
  data () {
    return {
      yearSelect: '',
      monthSelect: '',
      years: []
    }
  },
  created () {
    this.setYears()
  },
  methods: {
    exportMonth() {
      if (this.monthSelect !== '' && this.yearSelect !== '') {
        this.$store.commit('setexportMonth', { month: this.monthSelect, year: this.yearSelect })
        this.$router.push('/zlecenia/eksport')
      } else {
        Swal.fire('Podaj miesiąc i rok', '', 'warning')
      }
    },
    setYears() {
      this.years = [
        moment().subtract(2, 'years').year(),
        moment().subtract(1, 'years').year(),
        moment().year(),
        moment().add(1, 'years').year(),
        moment().add(2, 'years').year(),
      ]
    }
  }
}
</script>

<template>
  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="exampleModalLabel">wyświetl miesiąc</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <span>Wybierz rok</span>
          <select name="yearSelect" id="yearSelect" class="form-select" v-model="yearSelect">
            <option value="">rok</option>
            <option :value="year" v-for="year in years" :key="year">{{ year }}</option>
          </select>
          <p class="h4 mt-3">wyświetl miesiąc</p>
          <select name="monthSelect" id="monthSelect" class="form-select" v-model="monthSelect">
            <option value="01">Styczeń</option>
            <option value="02">Luty</option>
            <option value="03">Marzec</option>
            <option value="04">Kwiecień</option>
            <option value="05">Maj</option>
            <option value="06">Czerwiec</option>
            <option value="07">Lipiec</option>
            <option value="08">Sierpień</option>
            <option value="09">Wrzesień</option>
            <option value="10">Październik</option>
            <option value="11">Listopad</option>
            <option value="12">Grudzień</option>
          </select>
          <button type="button" class="btn btn-success mt-3" @click="exportMonth">Wyeksportuj miesiąc</button>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Zamknij</button>
        </div>
      </div>
    </div>
  </div>
</template>
